module.exports = __webpack_public_path__ + "static/media/arrow-fallen.81f93170.svg";